import React from 'react';
import { Translate } from '../../config/TranslationProvider';

const PriceList = ({prices}) => (
    <div className="widget atbd_widget widget-card">
        <div className="atbd_widget_title">
            <h4><span className="la la-euro" />&nbsp;<Translate value="price" /></h4>
        </div>
        <div className="directory_open_hours">
            <ul>
                {prices.map((price, key) => (
                    <li key={key}>
                        <span>{price.title}</span>
                        <span>{price.amount > 0 ? (price.amount).toFixed(2) + ' €' : <Translate value="for_free" />}</span>
                    </li>
                ))}
            </ul>
        </div>
    </div>
);

export default PriceList;
